import { get } from 'lodash'

export default {
  isEdit () {
    return get(this.$route.params, 'id', false)
  },
  isCreate () {
    return !get(this.$route.params, 'id', false)
  }
}



// WEBPACK FOOTER //
// ./src/crud/form/resources/computed.js